import React, { useState } from "react";
import Header from "../../components/Header";
import "./style.scss";
import FooterCustomer from "../../components/FooterCustomer";
import LoginDialog from "../../components/LoginDialog";
import EnterAuthCode from "../../components/EnterAuthCode";
import OrderIdle from "../../components/OrderIdle";
import orderStore from "../../stores/order";
import { useNavigate } from "react-router";
import {addToLog} from "../../helpers/ApiHelper";

const CustomerPage = () => {
    const navigate = useNavigate();

    const [isLogIntoAccount, setIsLogIntoAccount] = useState<boolean>(false);

    const showCodeDialog = () => {
        setIsLogIntoAccount(true);
    }

    const goNext = async () => {
        if (!orderStore.customerCode)
            return;

        const r = await orderStore.attachCustomerToOrder();
        if (r) {
            addToLog(`Set customer code: ${orderStore.customerCode}`);
            navigate("/menu#ns");
        }
        else {
            const r = await orderStore.attachInternalCardToOrder();
            if (r) {
                addToLog(`Set internal card code: ${orderStore.customerCode}`);
                navigate("/menu#ns");
            }
        }
    }

    return <div className="CustomerPage">
        <Header />
        {!isLogIntoAccount
            ? <LoginDialog onYes={showCodeDialog} />
            : <EnterAuthCode goNext={goNext} />
        }
        <FooterCustomer isLogIntoAccount={isLogIntoAccount} goNext={goNext} />
        <OrderIdle />
    </div>
}

export default CustomerPage;
